import React, {useEffect} from 'react';
import bg from "../../assets/fix-Q6TBVY8X.jpg";
import img from "../../assets/contacPageBg-cv4mvHDn.png";
import Form from "../Form";
import {useEmails, useGetEmails, useGetPhones, useGetSocials, usePhones, useSocials} from "../stores/contactStore";
import {FaInstagram, FaFacebook, FaTwitter, FaYoutube, FaTelegram, FaWhatsapp} from "react-icons/fa";
import Seo from "../utils/Seo";

const socialIcons = {
    instagram: FaInstagram,
    facebook: FaFacebook,
    twitter: FaTwitter,
    youtube: FaYoutube,
    telegram: FaTelegram,
    whatsapp: FaWhatsapp,
};
const ContactDetail = () => {
    const phones = usePhones()
    const getPhones = useGetPhones()
    const emails = useEmails()
    const getEmails = useGetEmails()
    const socials = useSocials()
    const getSocials = useGetSocials()
    useEffect(() => {
        void getEmails();
        void getSocials();
        void getPhones();
    }, [getEmails, getPhones, getSocials]);
    return (
        <>
            <Seo
                title="Контакты — Aluu Satuu | Агентство недвижимости в Кыргызстане"
                description="Свяжитесь с агентством недвижимости Aluu Satuu. Работаем ежедневно с 9:30 до 18:00. Телефоны, email, социальные сети. Бесплатная консультация."
                url={typeof window !== 'undefined' ? window.location.href : ''}
                image="/image.png"
            />
        <div>
            <div className="w-full md:w-4/6 mx-auto my-20 p-8 bg-white shadow-xl rounded-lg shadow-blue-100"><h2
                className="text-3xl font-bold mb-4">Aluu Satuu</h2>
                <img src={img}
                     alt="Офис агентства недвижимости Aluu Satuu в Бишкеке"
                     className="w-full h-[70vh] rounded-lg mb-4"/><p
                    className="text-xl font-semibold mb-2">Мы в соц. сетях</p>
                <div className="flex items-center mb-4">
                    <ul>
                        {socials.map((social) => {
                            const Icon = socialIcons[social.name.toLowerCase()];
                            return (
                                <li key={social.id}><a className={'flex gap-1'} href={social.url}>{Icon ?
                                    <Icon className="w-5 h-5"/> : null}{social.name}</a></li>
                            );
                        })}
                    </ul>
                </div>
                <p className="text-xl text-[#000] font-semibold mb-2">Наши контакты</p>
                <div className="flex flex-col mb-4">
                    <ul>
                        {phones.map((phone) => (
                            <li key={phone.id}>{phone.phone_number}</li>
                        ))}
                        {emails.map((email) => (
                            <li key={email.id}>{email.email}</li>
                        ))}
                    </ul>
                </div>
                <p className="text-xl font-semibold mb-2 text-[#222222]">Рабочий график</p><p
                    className="text-[#000] font-medium">Мы работаем каждый день без выходных:</p><p
                    className="text-[#000] font-medium"> с 9:30 - 18:00</p><p className="text-[#000] font-medium">Ищете
                    недвижимость на продажу или в аренду в районе Бишкека? Aluu Satuu облегчает этот поиск. Мы
                    предлагаем уникальную функцию геолокации для быстрого поиска идеальной квартиры, дома или участка.
                    Всего за несколько секунд мы поможем вам найти дом вашей мечты. Наша команда обладает обширными
                    знаниями в области недвижимости и готова помочь вам во всех аспектах процесса покупки или продажи
                    недвижимости. Будь то поиск вашего идеального дома, обсуждение новостроек в Бишкеке или помощь в
                    продаже вашей собственности, мы всегда готовы помочь. Не стесняйтесь обращаться к нам с любыми
                    вопросами.</p></div>
            {/*<div*/}
            {/*    className="px-2 relative text-white h-[50vh] w-full bg-center bg-no-repeat bg-cover"*/}
            {/*    style={{backgroundImage: `url(${bg})`}}*/}
            {/*    >*/}
            {/*    <div className="absolute inset-0 bg-black/60"></div>*/}
            {/*    <div className="relative container z-10 w-full h-full px-4 flex flex-col items-center justify-center">*/}
            {/*        <div*/}
            {/*            className="w-full md:w-2/3 md:p-6 p-3 rounded-lg shadow-md bg-[rgba(255, 255, 255, .15)] backdrop-blur mt-5">*/}
            {/*            <h3 className="md:text-xl text-center text-white">Для бесплатной консультации оставьте свои*/}
            {/*                контакты</h3>*/}
            {/*            <Form/>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
        </>
    );
};

export default ContactDetail;